export interface ICalendarDate {
  year: number;
  month: number;
  day: number;
}

export class CalendarDate {
  year: number;
  month: number;
  day: number;

  constructor() {
    const now = new Date();

    this.year = now.getFullYear();
    this.month = now.getMonth();
    this.day = now.getDate();
  }

  public static calendarDateToDate(date: ICalendarDate) {
    return new Date(date.year, date.month, date.day);
  }

  public static dateToCalendarDate(date: Date): ICalendarDate {
    return {
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate(),
    };
  }
}
